import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import client from '../../../Images/testi1.png';
import './Testimonial.css';

const Testimonial = () => {

    useEffect(() => {
        AOS.init({
            duration: 2000,
        });
        AOS.refresh();
    }, []);
    return (
        <section className="testimonial-wrapper">
            <Container>
                <Row>
                    <Col sm={12}>
                        <div className="section-title">
                            <h1>Testimonials</h1>
                        </div>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={6} lg={4} sm={12}>
                        <div className="client-box text-center" data-aos="fade-right">
                           
                            <h3 className="mt-4">GURU YADAV</h3>

                        </div>
                    </Col>
                    <Col md={6} lg={8} sm={12}>
                        <div className="review-item text-start" data-aos="zoom-out">
                            <h5>Awesome Work</h5>
                            <p>Best Hospital In Gomti nagar .
                                Price are very reasonable...</p>
                        </div>
                    </Col>

                </Row>


                <Row className="align-items-center">
                    <Col md={6} lg={4} sm={12}>
                        <div className="client-box text-center" data-aos="fade-right">
                            
                            <h3 className="mt-4">CHANDRA SHEKHAR</h3>

                        </div>
                    </Col>
                    <Col md={6} lg={8} sm={12}>
                        <div className="review-item text-start" data-aos="zoom-out">
                            <h5>Awesome Work</h5>
                            <p>Best doctor best medical n surgical services n very polite behavior staff.
                                Nice hospital n doctor with staff.</p>
                        </div>
                    </Col>

                </Row>









            </Container>
        </section>
    );
};

export default Testimonial;